import {PartsSearchService} from '../../../api/PartSearchService';
import {ImageService} from '../../../api/ImageService';
import _ from 'lodash';
import {HttpUtils} from "../../../api/common/HttpUtils";
import {StoreProxy} from "../../../api/common/StoreProxy";

// The dragTimer holds a reference to a piece of code that hides the
// drop zone for file uploads after a certain amount of time
var dragTimer = null;

/***********************************************************************
 * Responsible for determining whether the parameter passed into the method is a file 
 * @param {any} item - item whose file status is being determined
 */
async function isFile(item) {
    return new Promise((resolve) => {
        const fr = new FileReader();
        fr.onprogress = (e) => {
            if (e.loaded > 50) {
                fr.abort();
                resolve(true);
            }
        }
        //fr.onload = () => { resolve(true); }
        fr.onerror = () => { resolve(false); }
        fr.readAsArrayBuffer(item);
    });
}

export default {
    name: "ImageAdmin",
    data() {
        return {
            imageUploadComplete: 0,
            imageUploadFailed: 0,
            imageUploadFailedFiles: [],
            imageUploadTotal: 0,            
            isShowingDropZone: false,
            errorMessage: "",
            searchMessage: '',
            form: {
                partNumber: ''
            },
            results: {
                found: false,
                part: {},
                images: []
            },
            baseUploadImageUrl: '',
            uploadHeaders: {},
            imageOrderButtonEnabled: false,

        }
    },

    /***************************************************************************
     * Navigation guard that fires before navigating to the route (this page).       
     * @param {any} to - route to which the user is attempting to navigate (this page)
     * @param {any} from - route the user is attempting to leave 
     * @param {any} next - method that when called allows the navigation to occur
     */
    beforeRouteEnter (to, from, next) {
        next(vm => {
           let partNumber = to.params.partNumber;
            if (partNumber != null && partNumber !== ''){
                vm.searchPartNumber(partNumber);
            }
        });
    },

    /***************************************************************************
     * Navigation guard that fires when the parameters of the current route are updated.
     * As this is an update to the current route, the to and from parameters are going
     * to be the same and will be the current route.
     * be the same
     * @param {any} to - route to which the user is attempting to navigate 
     * @param {any} from - route the user is attempting to leave 
     * @param {any} next - method that when called allows the navigation to occur
     */
    beforeRouteUpdate (to, from, next){
        let partNumber = to.params.partNumber;
        if (partNumber != null && partNumber !== ''){
            this.clearSearchFields();
            this.searchPartNumber(partNumber);
        }
        next();
    },

    /***************************************************************************
     * Navigation guard that fires before the user an navigate to another route
     * @param {any} to - route to which the user is attempting to navigate
     * @param {any} from - route the user is attempting to leave
     * @param {any} next - method that when called allows the navigation to occur
     */
    beforeRouteLeave(to, from, next) {
        // When the save image order button is enabled it means that there
        // changes to the image order have occured but not been saved, so
        // prompt the user to make sure they are meaning to navigate away.
        if (this.imageOrderButtonEnabled) {
            this.$confirm('You have not saved the image order.  Continue?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            })
            .then(() => {
                next();
            });
        } else {
            next();
        }
    },
    created(){
        this._$imageService = new ImageService(StoreProxy.getAuth(this.$store));        
    },
    mounted() {
        this.baseUploadImageUrl =  `${process.env.VUE_APP_API_URL}/v1/images`;
        this.uploadHeaders = HttpUtils.getHttpHeaders(StoreProxy.getAuth(this.$store), null);

        // Setup drag/drop event listeners
        window.document.addEventListener("keydown", this.keyDown); 
        window.document.addEventListener("dragover", this.onDragOver)
    },
    beforeDestroy() {
        // Remove registered event listeners
        window.document.removeEventListener("keydown", this.keyDown);
        window.document.removeEventListener("dragover", this.onDragOver)
    },
    computed: {
        uploadImageUrl() {
            return `${this.baseUploadImageUrl}/${this.form.partNumber}/add`;
        }
    },
    methods: {
        onSingleFileUploadError(e) {
            this.errorMessage = "Failed to upload image";
            setTimeout(() => {
                this.errorMessage = "";
            }, 5000);
        },
        clearSearchFields(){
            this.form.partNumber = '';
        },
        keyDown(e) {
            console.log(e.key);
            if (e.key === "Escape") {
                this.isShowingDropZone = false;
            }
        },
        onDragOver(e) {
            
            if (this.results.found) {
                this.isShowingDropZone = true;
                if (dragTimer) {
                    window.clearTimeout(dragTimer);
                }
                if (dragTimer) {
                    window.clearTimeout(dragTimer);
                }
            }

            const vm = this;
            dragTimer = window.setTimeout(() => {
                vm.isShowingDropZone = false;
            }, 100);

            e.stopPropagation();
        },        
        onDropFiles(e) {
            e.preventDefault();
            e.stopPropagation();

            if (dragTimer) {
                window.clearTimeout(dragTimer);
            }

            const promises = [];
            const files = [];

            // Iterate over each item that was dropped in the drop zone
            for (var i = 0; i < e.dataTransfer.items.length; i++) {
                var item = e.dataTransfer.items[i];
                if (item.kind === "file") {
                    var file = e.dataTransfer.files[i];
                    files.push(file);
                    promises.push(isFile(file));
                } else {
                    files.push(null); // This keeps the array indexing correct between files/promises
                    promises.push(Promise.resolve(false));
                }
            }

            // Ensure all promises are resolved before moving on
            const vm = this;
            Promise.all(promises)
                .then(results => {

                    // Reset image upload information
                    vm.imageUploadTotal = results.filter(i => i === true).length;
                    vm.imageUploadComplete = 0;
                    vm.imageUploadFailed = 0;
                    vm.imageUploadFailedFiles = [];
                    
                    const partNumber = vm.$data.form.partNumber;
                    const imageUploads = [];      
                    let needRefresh = false;

                    // Iterate through all of the "isFile" results
                    for (var i = 0; i < results.length; i++) {
                        if (results[i] === true) {
                            imageUploads.push(vm.uploadImage(partNumber, files[i]));
                            needRefresh = true;
                        } else {
                            console.log(`Item ${i+1} of ${results.length} dropped into drop zone was not a file.`);
                        }
                    }                    

                    // Wait for all of the image uploads to occur
                    Promise.all(imageUploads)
                        .then(() => {
                            if (needRefresh) {
                                vm.onUploadSuccess();
                            } else {
                                vm.isShowingDropZone = false;
                            }                    
                        })
                        .catch((ex) => {
                            vm.onUploadSuccess();
                            vm.isShowingDropZone = false;
                        });           
                });

            e.target.classList.remove("dragover");
        },
        uploadImage(partNumber, imageFile) {
            const me = this;
            return this._$imageService.addImage(partNumber, imageFile)
                .then(() => {
                    // Single image upload succeeded
                    me.imageUploadComplete += 1;
                    me.checkIfUploadsComplete();
                })
                .catch(ex => {
                    // Single image upload failed
                    me.imageUploadComplete += 1;
                    me.imageUploadFailed += 1;
                    me.imageUploadFailedFiles.push(imageFile.name);
                    me.checkIfUploadsComplete();
                });
        },
        checkIfUploadsComplete() {
            const me = this;
            if (this.imageUploadTotal == this.imageUploadComplete) {
                setTimeout(() => {
                    me.imageUploadTotal = 0;
                    me.imageUploadComplete = 0;
                }, 1000);
            }
        },
        onSearch(){
          this.searchPartNumber();
        },
        searchPartNumber(partNumber) {
            let partSearchService = new PartsSearchService(StoreProxy.getAuth(this.$store), error => {
                this.found = false;
                this.part = {};
                this.$notify.error({
                    title: 'Error',
                    message: 'Error while searching part number on the server.\nTry Again!'
                });
            });

            // Determine whether a part number was passed into the method. If so update the part 
            // number on the form, otherwise just use the part number associated with the form 
            // which will be the part number the user typed into the part number textbox.            
            if (partNumber != null){
                this.form.partNumber = partNumber;
            }
            else
            {
                // Not entirely sure why this is here but an error kept appearing in the console
                // about "Avoided redundant navigation to current location" so I put a condition
                // to avoid pushing the route if its the current route already.
                if (this.$router.currentRoute.fullPath != '/mgt/images') {
                    this.$router.push('/mgt/images');
                }
            }

            if (this.form.partNumber.length === 0) {
                return;
            }

            partSearchService.getPartSummary(this.form.partNumber, partResult => {
                this.loadImages()
                    .then(images => {
                        this.results.part = partResult;
                        this.results.found = true;
                    });
            }, notFound => {
                this.results.part = {};
                this.results.images = [];
                this.results.found = false;
                this.searchMessage = `Part Number ${this.form.partNumber} not found!`
            })
        },
        onUploadSuccess() {
            const vm = this;
            setTimeout(() => {
                vm.loadImages()
                    .then(() => vm.isShowingDropZone = false)
                    .catch(() => vm.isShowingDropZone = false);
            }, 1200);
        },

        /***********************************************************************
         * Fires when an image fails to load
         * @param {any} item - reference to the part whose image failed to load
         */
        onImageError(item) {
            item.imageLoadFailures += 1;
            if (item.imageFailures <= 3) {
                setTimeout(function () {
                    // Split the image URI and only use the first part to avoid building out a huge URI string
                    item.thumbnailUri += item.thumbnailUri.split("?")[0] + '?' + new Date;
                }, 1000);
            }
        },

        /***********************************************************************
         * Loads the images for the currently loaded part
         * @returns a promise representing the API call to loading images for the specified part
         */
        loadImages(){
            return this._$imageService.getImages(this.form.partNumber)
                .then(partImages => {
                    if (partImages != null) {
                        this.results.images = partImages.map((item, index) => {
                            item.imageLoadFailures = 0; // Used to flag whether an image load failed
                            item.indexOrig = item.index; // Used to check if order index changed
                            return item;
                        });
                    }
                    else {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Images not found.'
                        });
                    }
                })
                .catch(error => {
                    this.results.images = [];
                    console.error('[e203677] Error getting images');
                    if (error != null) {
                        console.error(error);
                    }
                });
        },

        /***********************************************************************
         * Responsible for saving the current order of the images.
         */
        onSaveImageOrder(){
            let imagesOrder = [];

            // Poulate image ids with order index for submission to the order
            // update API.  We use the positional index of the image in the 
            // array for the image order index because the array is sorted.  This 
            // ensures the index values are normalized when saving.
            this.results.images.forEach((item,index) => {
               imagesOrder.push({
                  imageId: item.imageId,
                  order: index+1
               });
            });

            let vm = this;
            this._$imageService.updateOrder(this.results.part.partNumber, imagesOrder)
                .then(data => {
                    // Save was successful then go back and update the indexes of each 
                    // item with the positional index to match what was just saved
                    this.results.images.forEach((item, index) => {
                        item.index = index + 1;
                        item.origIndex = item.index;
                    })
                    
                    vm.imageOrderButtonEnabled = false;

                    this.$notify({
                        title: 'Success',
                        message: 'Order Updated!',
                        type: 'success'
                    });
                    vm.loadImages();
                })
                .catch(error => {
                    console.error('[e436548] Failed updating image error');
                    if (error != null) {
                        console.error(error);
                    }
                    this.$notify.error({
                        title: 'Server Error',
                        message: 'Failed to update order. '
                    });
                });
        },

        /***********************************************************************
         * Fires when the user clicks on the delete image button.
         * @param {any} imageId - ID of the image to delete
         */
        onImageDelete(imageId){
            this.$confirm('This will permanently delete the image. Continue?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.deleteImage(imageId);
            }).catch(() => {
                console.log("user cancelled image deletion.");
            });
        },

        /***********************************************************************
         * Responsible for calling the API to delete the specified image
         * @param {any} imageId - ID of the image to delete
         */
        deleteImage: function (imageId) {

            this._$imageService.deleteImage(this.results.part.partNumber, imageId).then(() => {

                this.$notify({
                    title: 'Success',
                    message: 'Image Deleted!',
                    type: 'success'
                });

                this.results.images = _.remove(this.results.images, function (o) {
                    return (o.imageId !== imageId);
                });

            }).catch(error => {

                console.error('[e169858] Failed to delete image.');
                if (error != null) {
                    console.error(error);

                    this.$notify.error({
                        title: 'Server Error',
                        message: 'Failed to update order. '
                    });
                }
            });
        },

        /**
         * Fires when the image order control changes.
         * @param {any} updatedImg - reference to the item whose order changed
         * @param {any} newIndex - new image index
         * @param {any} oldIndex - old image index
         * @returns true indicating to the control that the change is allowed
         */
        onImageOrderChange(updatedImg, newIndex, oldIndex) {

            //NOTE: pre 12/17/2025 there was something in this method with _$timeoutId
            // and code that ran inside a timeout.  There were no comments about why
            // but if we see weird behavior then it may be good to look at the code
            // repo history to see if was there for a good reason.

            // Determine whether there are any ordering changes
            let hasOrderChanges = false;
            this.results.images.forEach(i => {
                if (i.index != i.indexOrig) {
                    hasOrderChanges = true;
                }
            });

            // Make sure to show the save order button if there are changes
            this.imageOrderButtonEnabled = hasOrderChanges;

            // Swap indexes for the current item and whatever item matches its new index
            this.results.images.forEach(img => {
                if (img != updatedImg && img.index === newIndex) {
                    img.index = oldIndex;
                }
            });

            // Sort the images so they appear in the order the user has specified.
            // NOTE: for some reason swapping the index and then sorting the array
            // resulted in the UI showing the wrong index on the swapped item. It
            // seems to work if you let the index swap out and then "wait" before
            // running the sort.
            var vm = this;
            setTimeout(() => {
                vm.results.images.sort((a, b) => { return a.index - b.index });                
            }, 500);

            return true;
        }
    }
}